import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import Logo from "../../Images/Logo.png";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Check, Logout } from "@mui/icons-material";
import ListSubheader from "@mui/material/ListSubheader";
import Divider from "@mui/material/Divider";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DescriptionIcon from '@mui/icons-material/Description';
import CategoryIcon from "@mui/icons-material/Category";
import {useTheme} from "@mui/material/styles";
import {PortalLink} from "@kinde-oss/kinde-auth-react/components";
import {useContext, useEffect, useState} from "react";
import LoadingOverlay from "../Loading/LoadingOverlay";
import {IsOnboardedContext} from "../../Contexts/IsOnboardedContext";
import {useKindeAuth} from "@kinde-oss/kinde-auth-react";

const pages = ["Projects", "Clients", "Products"];

function NavBar() {
	const [anchorElNav, setAnchorElNav] = useState(null);
	const [anchorElUser, setAnchorElUser] = useState(null);
    const [loading, setLoading] = useState(false);

	const theme = useTheme();
    const context = useContext(IsOnboardedContext);
    const { logout, login, getClaim } = useKindeAuth();
    const [organizations, setOrganizations] = useState([]);

    useEffect(() => {
        getClaim("organizations", "idToken")
            .then(claim => setOrganizations(claim?.value || []))
            .catch(error => console.error('Error fetching organizations:', error));
    }, [getClaim]);

	const handleOpenNavMenu = (event) => {
		setAnchorElNav(event.currentTarget);
	};

	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseNavMenu = () => {
		setAnchorElNav(null);
	};

	const handleCloseUserMenu = () => {
		setAnchorElUser(null);
	};

	const navigate = useNavigate();

    const handleLogout = () => {
        sessionStorage.setItem('hasLoggedOut', 'true');
        logout()
            .then(r => {
                console.log('Logout successful:', r);
                handleCloseUserMenu();
            })
            .catch(error => {
                console.error('Logout failed:', error);
                handleCloseUserMenu();
            });
    }


    const handleSwitchOrganization = (orgCode) => {
        if (orgCode === context.orgDetails?.code) {
            handleCloseUserMenu();
            return;
        }
        setLoading(true);
        login({ orgCode })
            .catch(error => {
                console.error('Organization switch failed:', error);
                setLoading(false);
            });
    };

    const toParametersPage = () => {
		navigate("/management/parameters");
		handleCloseUserMenu();
	};

	const toTemplatesPage = () => {
		navigate("/management/templates");
		handleCloseUserMenu();
	};

	const toCategoriesPage = () => {
		navigate("/management/categories");
		handleCloseUserMenu();
	};

	return <>
            {loading && <LoadingOverlay />}
            <AppBar position='fixed'>
                <Container maxWidth='xl'>
                    <Toolbar disableGutters>
                        <Box>
                            <Tooltip title='Home'>
                                <Link to={"/"}>
                                    <Box
                                        component='img'
                                        sx={{
                                            height: 50,
                                            flexGrow: 1,
                                            display: { xs: "none", md: "flex" },
                                            mr: 2,
                                        }}
                                        alt='Cybernation Industries logo'
                                        src={Logo}
                                    />
                                </Link>
                            </Tooltip>
                        </Box>

                        <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                            <IconButton
                                size='large'
                                aria-label='account of current user'
                                aria-controls='menu-appbar'
                                aria-haspopup='true'
                                onClick={handleOpenNavMenu}
                                color='inherit'
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id='menu-appbar'
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: "block", md: "none" },
                                }}
                            >
                                {pages.map((page) => (
                                    <MenuItem
                                        key={page}
                                        onClick={handleCloseNavMenu}
                                    >
                                        <Link
                                            to={page}
                                            key={page}
                                            style={{ color: "#000" }}
                                        >
                                            <Typography textAlign='center'>{page}</Typography>
                                        </Link>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                        <Box sx={{ flexGrow: { xs: 1, md: 0 } }}>
                            <Tooltip title='Home'>
                                <Link to={"/"}>
                                    <Box
                                        component='img'
                                        sx={{
                                            height: 50,
                                            flexGrow: 1,
                                            display: { xs: "flex", md: "none" },
                                            mr: 2,
                                        }}
                                        alt='Cybernation Industries logo'
                                        src={Logo}
                                    />
                                </Link>
                            </Tooltip>
                        </Box>
                        <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
                            {pages.map((page) => (
                                <Link
                                    to={page}
                                    key={page}
                                >
                                    <Button
                                        key={page}
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: "white", display: "block" }}
                                    >
                                        {page}
                                    </Button>
                                </Link>
                            ))}
                        </Box>

                        <Box sx={{ flexGrow: 0 }}>
                            <Tooltip title='Open settings'>
                                <IconButton
                                    onClick={handleOpenUserMenu}
                                    sx={{ p: 0 }}
                                >
                                    <Avatar
                                        alt={context.userName}
                                        src={context.user.picture}
                                    />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: "35px" }}
                                id='menu-appbar'
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                slotProps={{
                                    paper: {
                                        elevation: 0,
                                        sx: {
                                            overflow: "visible",
                                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                            mt: 1.5,
                                            "& .MuiAvatar-root": {
                                                width: 32,
                                                height: 32,
                                                ml: -0.5,
                                                mr: 1,
                                            },
                                            "&::before": {
                                                content: '""',
                                                display: "block",
                                                position: "absolute",
                                                top: 0,
                                                right: 14,
                                                width: 10,
                                                height: 10,
                                                bgcolor: "background.paper",
                                                transform: "translateY(-50%) rotate(45deg)",
                                                zIndex: 0,
                                            },
                                        },
                                    },
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <MenuItem onClick={toCategoriesPage}>
                                    <ListItemIcon>
                                        <CategoryIcon fontSize='small' sx={{color: theme.palette.tertiary.secondary}} />
                                    </ListItemIcon>
                                    Categories
                                </MenuItem>
                                <MenuItem onClick={toParametersPage}>
                                    <ListItemIcon>
                                        <FormatListBulletedIcon fontSize='small' sx={{color: theme.palette.tertiary.secondary}} />
                                    </ListItemIcon>
                                    Parameters
                                </MenuItem>
                                <MenuItem onClick={toTemplatesPage}>
                                    <ListItemIcon>
                                        <DescriptionIcon fontSize="small" sx={{color: theme.palette.tertiary.secondary}} />
                                    </ListItemIcon>
                                    Templates
                                </MenuItem>
                                {organizations.length > 1 && [
                                    <Divider key='org-divider' />,
                                    <ListSubheader key='org-header' sx={{ lineHeight: "32px" }}>
                                        Switch organization
                                    </ListSubheader>,
                                    ...organizations.map((org) => {
                                        const isCurrent = org.id === context.orgDetails?.code;
                                        return (
                                            <MenuItem
                                                key={org.id}
                                                selected={isCurrent}
                                                onClick={() => handleSwitchOrganization(org.id)}
                                            >
                                                <ListItemIcon>
                                                    {isCurrent && <Check fontSize='small' />}
                                                </ListItemIcon>
                                                {org.name}
                                            </MenuItem>
                                        );
                                    }),
                                ]}
                                <Divider />
                                <PortalLink className={"portal-link-reset"}>
                                    <MenuItem onClick={() => setLoading(true)}>
                                        <ListItemIcon>
                                            <ManageAccountsIcon fontSize='small' />
                                        </ListItemIcon>
                                        My Account
                                    </MenuItem>
                                </PortalLink>
                                <MenuItem onClick={handleLogout}>
                                    <ListItemIcon>
                                        <Logout fontSize='small' />
                                    </ListItemIcon>
                                    Logout
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </>;
}
export default NavBar;
